module.exports = __webpack_public_path__ + "img/TecnicoEAM.364e0db7.png";